import { SpaceEventMessage as _SpaceEventMessage } from "./SpaceApi";

export { default } from "./SpaceApi";

export type SpaceEventMessage = _SpaceEventMessage;
